import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FrattaleService } from 'src/app/services/frattale.service';

@Component({
  selector: 'app-lista-pulsanti-mercati',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lista-pulsanti-mercati.component.html',
  styleUrl: './lista-pulsanti-mercati.component.scss'
})
export class ListaPulsantiMercatiComponent {
  @Input() soloForex: boolean = false
  @Output() mercatoSelezionato = new EventEmitter<any>()
  markets: any[] = []

  constructor(private serv: FrattaleService) { }

  ngOnInit(): void {
    this.serv.getMarkets().subscribe((data: any) => {
      if (data.res == 'ok') {
        if (this.soloForex) {
          this.markets = data.data.filter((el: any) => el.tipo == "Cross" || el.tipo == "Major")
        }
        else {
          this.markets = data.data
        }
      } 
    })
  }

  selMarket(mkt: any) {
    this.mercatoSelezionato.emit(mkt)
  }

}
